// extracted by mini-css-extract-plugin
export var bubble = "_34-0";
export var container = "_34-f";
export var contrastBorder = "_34-g";
export var greyOut = "_34-2";
export var initialsColor0 = "_34-3";
export var initialsColor1 = "_34-4";
export var initialsColor10 = "_34-d";
export var initialsColor11 = "_34-e";
export var initialsColor2 = "_34-5";
export var initialsColor3 = "_34-6";
export var initialsColor4 = "_34-7";
export var initialsColor5 = "_34-8";
export var initialsColor6 = "_34-9";
export var initialsColor7 = "_34-a";
export var initialsColor8 = "_34-b";
export var initialsColor9 = "_34-c";
export var initialsWrapper = "_34-1";
export var large = "_34-l";
export var medium = "_34-k";
export var mediumSmall = "_34-j";
export var mediumSmallMedium = "_34-o";
export var micro = "_34-h";
export var small = "_34-i";
export var tiny = "_34-n";
export var xTiny = "_34-m";